import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUmbrellaBeach, faLayerGroup, faFileContract, faShip, faFileInvoiceDollar, faAddressBook, faListCheck, faArrowRight,
} from '@fortawesome/free-solid-svg-icons';
import { useGoTo, WidgetEmpty } from './common';

const ICONS = {
  leave: faUmbrellaBeach,
  offer: faLayerGroup,
  recap: faFileContract,
  delivery: faShip,
  invoice: faFileInvoiceDollar,
  crm: faAddressBook,
  todo: faListCheck,
};

const QuickActionsWidget = ({ data }) => {
  const goTo = useGoTo();
  const actions = data.actions || [];
  if (actions.length === 0) return <WidgetEmpty>No shortcuts available.</WidgetEmpty>;
  return (
    <div className="mydesk-quick">
      {actions.map((a) => (
        <button key={a.key} type="button" className="mydesk-quick-btn" onClick={() => goTo(a.url)}>
          <FontAwesomeIcon icon={ICONS[a.icon] || faArrowRight} />
          <span>{a.label}</span>
        </button>
      ))}
    </div>
  );
};

export default QuickActionsWidget;
